module.exports = __webpack_public_path__ + "static/food-bank-e08c5531f9dda6fa2b0cac47ecfb3680.jpg";